import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function getLivingVariantTypes() {
  return query(gql`
    query Living_variant_types {
      living_variant_types {
        disclaimer
        id
        type
      }
    }
  `)
}

export async function getLivingVariants() {
  return query(gql`
    query Living_variants {
      living_variants {
        id
        configuration
        living_variant_type {
          id
          type
        }
      }
    }
  `)
}

export async function upsertLivingVariant(payload) {
  return mutate(
    {
      livingVariants: [payload],
    },
    gql`
      mutation Upsert_living_variants($livingVariants: [living_variants_input]) {
        upsert_living_variants(living_variants: $livingVariants) {
          id
        }
      }
    `,
  )
}
